import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import Image from "./image";

import * as styles from "../styles/components/fc-partners.module.css";

interface ImageAsset {
  asset?: {
    _id?: string;
  };
  alt?: string;
}

interface LogoItem {
  _key?: string;
  logo?: ImageAsset;
  link?: string;
}

interface PartnersProps {
  title?: string;
  logos?: LogoItem[];
}

const Partners: React.FC<PartnersProps> = ({
  title,
  logos
}) => {
  if (!logos || logos.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        <div className="grid">
          {title && (
            <div className="col-lg-7">
              <h2 className={cn("h3", styles.title)}>{title}</h2>
            </div>
          )}

          <div className="col-lg-5 offset-lg-7">
            <div className={styles.logos}>
              {logos.map(({ _key, logo, link }) => (
                <div className={styles.item} key={_key}>
                  {link ? (
                    <a href={link} target="_blank" rel="noreferrer">
                      <Image node={logo} />
                    </a>
                  ) : (
                    <Image node={logo} />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Partners;
